import React from "react";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		backgroundColor: theme.palette.colors.transparent,
		paddingBottom: "10px",
	},
	messageWarning: {
		alignItems: "center",
		marginBottom: "50px",
		color: theme.palette.colors.purplishBlue,
		fontSize: "14px",
		fontFamily: "MuseoSansCyrl-500",
		paddingLeft: "40px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		messageWarning: {
			alignItems: "center",
			marginBottom: "50px",
			color: theme.palette.colors.purplishBlue,
			fontSize: "14px",
			fontFamily: "MuseoSansCyrl-500",
			paddingLeft: "25px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		messageWarning: {
			alignItems: "center",
			marginBottom: "50px",
			color: theme.palette.colors.purplishBlue,
			fontSize: "14px",
			fontFamily: "MuseoSansCyrl-500",
			paddingLeft: "0px",
		},
	},
});

class NoFindTariffs extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		let text = this.props.text;
		return (
			<div className={classes.root}>
				<Container>
					<Row className={classes.messageWarning}>
						<span>{text.NO_FIND_TARIFFS}</span>
					</Row>
				</Container>
			</div>
		);
	}
}

export default withStyles(styles)(NoFindTariffs);
